export default __webpack_public_path__ + "41590ae498e78957a18980f4d3979ac7.png";